import { createSlice } from "@reduxjs/toolkit";
import uploadImageMicroscopy from "@custom/rtk-apis/microscopy";

const initialState = {
  status:"",
  result:{},
  message:"",
  loading:false,
  error:""
};

const uploadImageMicroscopySlice = createSlice({
  name: "uploadImageMicroscopy",
  initialState,
  reducers: {
    resetUploadImageState: () => initialState,
    resetStatus (state:any) { state.status = ""; }
  },
  extraReducers: (builder) => {
    console.log("----------",builder)
    builder
      .addCase(uploadImageMicroscopy.pending, (state, action) => {
        console.log("Pending")
        state.loading = true;
      })
      .addCase(uploadImageMicroscopy.fulfilled, (state, { payload }) => {
        console.log("Fulfilled",payload)
        state.loading = false;
        state.status = payload.status;
        state.result = payload.result;
        state.msg = payload.msg;
      })
      .addCase(uploadImageMicroscopy.rejected, (state, { payload }) => {
        console.log("Rejected")
        state.result = payload;
        state.loading = false;
      });
  },
});

export default uploadImageMicroscopySlice.reducer;
export const { resetStatus , resetUploadImageState} = uploadImageMicroscopySlice.actions;
